
(function(){
  function discountUrl(code){
    var redirect = window.KAYWOOT_DISCOUNT_REDIRECT || '/cart';
    return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
  }
  window.applyKayWootCode = function(code, event){
    if(event) event.preventDefault();
    try { navigator.clipboard && navigator.clipboard.writeText(code); } catch(e) {}
    var toast = document.querySelector('[data-kw-toast]');
    if(toast){
      toast.textContent = code + ' copied. Sending you to cart...';
      toast.classList.add('show');
    }
    window.location.href = discountUrl(code);
    return false;
  };
  document.querySelectorAll('[data-apply-code]').forEach(function(el){
    var code = el.getAttribute('data-apply-code');
    el.setAttribute('href', discountUrl(code));
  });
})();
